import { useNavigate } from "react-router-dom";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";


const employeeListData = [
    {
        name: "Hitesh Patel",
        designation: "MR",
        reportingTo: "ASM",
        hq: "Ahmedabad",
        submitted: "10 Jul 2024",
        req:'₹1200',
        aprr:'₹1000',
        audit: "-",
        wd: "20",
        totalFWcall: "150",
        totalNCA: "5",
    },
    {
        name: "Manish Shah",
        designation: "ASM",
        reportingTo: "RM",
        hq: "Surat",
        submitted: "12 Jul 2024",
        req:'₹1500',
        aprr:'₹1200',
        audit: "-",
        wd: "22",
        totalFWcall: "160",
        totalNCA: "7",
    },
    {
        name: "Kiran Mehta",
        designation: "RM",
        reportingTo: "ZM",
        hq: "Orai",
        submitted: "08 Jul 2024",
        req:'₹2000',
        aprr:'₹1800',
        audit: "-",
        wd: "25",
        totalFWcall: "180",
        totalNCA: "10",
    },
    {
        name: "Priya Desai",
        designation: "MR",
        reportingTo: "ASM",
        hq: "Rajkot",
        submitted: "14 Jul 2024",
        req:'₹1000',
        aprr:'₹900',
        audit: "-",
        wd: "18",
        totalFWcall: "140",
        totalNCA: "6",
    },
    {
        name: "Rajesh Parmar",
        designation: "ZM",
        reportingTo: "NSM",
        hq: "Bhavnagar",
        submitted: "09 Jul 2024",
        req:'₹3000',
        aprr:'₹2800',
        audit: "-",
        wd: "28",
        totalFWcall: "200",
        totalNCA: "15",
    },


]

// const filterOptions = [
//     {
//         label: "Designation",
//         options: [
//             { id: "mr", label: "MR" },
//             { id: "asm", label: "ASM" },
//             { id: "rm", label: "RM" },
//             { id: "zm", label: "ZM" },
//             { id: "nsm", label: "NSM" },
        
//         ],
//     },

//     {
//         label: "Expense Status",
//         options: [
//             { id: "onHold", label: "On Hold" },
//             { id: "submitted", label: "Submitted" },
//             { id: "aprr", label: "Approved" },
//             { id: "audit", label: "Audited" },
        
//         ],
//     },

    
// ];

const filterOptions = [
    { id: "All", label: "All" },
    { id: "Raised", label: "Raised" },
    { id: "Approved", label: "Approved" },
    { id: "Rejected", label: "Rejected" },
  ];
const ExpAuditEmployeeList = () => {
    const navigate = useNavigate();

    const employeeColumns = (handleEmpView: (row: any) => void) => [
     
        {
            name: "Name",
            selector: (row: { name: number | string }) => row.name,
            sortable: true,
        },
        {
            name: 'Designation',
            selector: (row: { designation: string }) => row.designation,
            sortable: true,
        },
        {
            name: "Reporting To",
            selector: (row: { reportingTo: string }) => row.reportingTo,
            sortable: true,
        },
        {
            name: " HQ (City )",
            selector: (row: { hq: string }) => row.hq,
            sortable: true,
        },

        {
            name: "Submitted",
            selector: (row: { submitted: string }) => row.submitted,
            sortable: true,
        },
        {
            name: "Requested",
            selector: (row: { req: string }) => row.req,
            sortable: true,
        },
        {
            name: "Approved",
            selector: (row: { aprr: string }) => row.aprr,
            sortable: true,
        },
        {
            name: "Audited",
            selector: (row: { audit: string }) => row.audit,
            sortable: true,
        },
        {
            name: "Working Day",
            selector: (row: { wd: string }) => row.wd,
            sortable: true,
        },
        {
            name: "Total FW Calls",
            selector: (row: { totalFWcall: string }) => row.totalFWcall,
            sortable: true,
        },
        {
            name: "Tatal NCA",
            selector: (row: { totalNCA: string }) => row.totalNCA,
            sortable: true,
        },

        {
            name: "Actions",
            cell: (row: any) => (
                <button
                    onClick={() => handleEmpView(row)}
                    className="btn btn-primary"
                    style={{ borderRadius: "20px", padding: "5px", width: "55px", height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px' }}>
                    View
                </button>
            ),
        },
    ];


    const handleEmpView = () => {
      navigate('/expense/expenses/employeeList/employeeExpView')
    };
    return (
        <div
        className="container mt-3"
       >
          <PageHeader
                title="Employee"
                
             
            />
        <div
            style={{
             
                display: "flex",
                justifyContent: "center",
                margin: "auto",
                marginTop: "2%",
            }}
        >
            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <BasicDataTable
                    search={true}
                    Title="Employee"
                    columns={employeeColumns(handleEmpView)}
                    data={employeeListData}
                    tableHeaderButtonAfterSearch={true}
                    // filterOptions={filterOptions}
                    headerButtonAfterSearchContent={
                        <div
                        style={{
                          marginBottom: "15px",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <RoundedDropdown
                          options={filterOptions}
                          onSelect={()=>console.log('Hii')}
                          defaultLabel="All"
                          width="120px"
                          isShowHeading
                          DropdownHeading="Status"
                          headingColor="#2e8dd3"
                        />
                      </div>
                    }

                />
            </div>
        </div>
        </div>

    );
};

export default ExpAuditEmployeeList;



